<template>
    <b-modal :visible="value" title="Доступ к графикам" size="xl" ok-title="Сохранить" cancel-title="Отмена"
             :ok-disabled="loading || saving || !loaded" :cancel-disabled="saving" :no-close-on-backdrop="true"
             :no-close-on-esc="saving" :hide-header-close="saving" @change="$emit('input', $event)" @ok="save">
        <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>
        <div v-if="loading" class="text-center p-4"><b-spinner small/> Загрузка настроек…</div>
        <template v-else-if="loaded">
            <p class="text-muted">Эти права дают доступ только к аналитике. Карточки объектов и отчёты имеют собственные настройки. Admin всегда имеет доступ.</p>
            <b-form-checkbox v-model="config.enabled" switch class="mb-3">Доступ по назначениям включён</b-form-checkbox>
            <b-tabs content-class="pt-3">
                <b-tab title="Все объекты" active>
                    <MultipleParticipantsConfig v-model="config.full_access" :users="users" :departments="departments"
                        :allowed-types="['all', 'specific_users', 'department']" :show-priority="false" :show-fallback-option="false"
                        participant-label="получателя доступа" empty-text="Доступ ко всем объектам не назначен"
                        hint-text="Эти участники видят графики всех объектов своей компании, включая архив."/>
                </b-tab>
                <b-tab title="По назначению">
                    <MultipleParticipantsConfig v-model="config.object_access" :users="users" :departments="departments"
                        :allowed-types="['object_role']" :show-object-roles="true" :object-role-options="roles"
                        :show-priority="false" :show-fallback-option="false" participant-label="объектную роль"
                        empty-text="Автоматический доступ по объектным ролям не назначен"
                        hint-text="Доступ действует только на объектах, где пользователь назначен на выбранную роль."/>
                </b-tab>
                <b-tab title="Конкретные объекты">
                    <label for="charts-access-object">Объект</label>
                    <v-select v-model="selected" :options="objects" label="name" :reduce="object => object.building_process_id"
                        input-id="charts-access-object" placeholder="Найти объект" class="mb-3"><template #search="{attributes, events}"><input class="vs__search" v-bind="attributes" aria-label="Объект для настройки доступа" :aria-labelledby="null" v-on="events"/></template></v-select>
                    <MultipleParticipantsConfig v-if="selectedObject" :key="selected" :value="selectedObject.access_config"
                        :users="users" :departments="departments" :allowed-types="['specific_users', 'department', 'object_role']"
                        :show-object-roles="true" :object-role-options="roles" :show-priority="false" :show-fallback-option="false"
                        participant-label="получателя доступа" empty-text="Отдельный доступ к этому объекту не назначен"
                        hint-text="Все изменения в этом окне сохраняются одной кнопкой «Сохранить»."
                        @input="changeObject"/>
                </b-tab>
            </b-tabs>
        </template>
    </b-modal>
</template>
<script>
import chartsApi from '@/utils/api/chartsApi';
import MultipleParticipantsConfig from '@/views/Requests/RequestTypes/MultipleParticipantsConfig/MultipleParticipantsConfig.vue';
export default {
    name: 'ChartsAccessSettings', components: {MultipleParticipantsConfig}, props: {value: Boolean},
    data: () => ({loading: false, saving: false, loaded: false, error: '', config: {}, objects: [], selected: null, changed: [], updatedAt: null,
        roles: [{value: 'main_staff', text: 'Прораб'}, {value: 'curator', text: 'Куратор'}, {value: 'has_access', text: 'Имеют доступ'}]}),
    computed: {
        users() {return (this.$store.state.users || []).filter(user => user.user_id).map(user => ({value: user.user_id, text: user.full_name || `${user.last_name || ''} ${user.first_name || ''}`.trim()}));},
        departments() {return (this.$store.state.departments || []).map(row => ({value: row.id, text: row.name}));},
        selectedObject() {return this.objects.find(object => object.building_process_id === this.selected);}
    },
    watch: {value(value) {if (value) this.load();}},
    methods: {
        async load() {
            this.loading = true; this.loaded = false; this.error = ''; this.changed = []; this.selected = null;
            try {
                const [settings, objects] = await Promise.all([chartsApi.settings(), chartsApi.objectAccess(), this.$store.dispatch('getUsers'), this.$store.dispatch('getDepartments')]);
                this.config = settings.access_config; this.updatedAt = settings.updated_at; this.objects = objects.items; this.loaded = true;
            } catch (error) {this.error = error.response && error.response.data.msg || 'Не удалось загрузить настройки';}
            finally {this.loading = false;}
        },
        changeObject(value) {
            this.$set(this.selectedObject, 'access_config', value);
            if (!this.changed.includes(this.selected)) this.changed.push(this.selected);
        },
        async save(event) {
            event.preventDefault(); this.saving = true; this.error = '';
            try {
                await chartsApi.saveSettings({access_config: this.config, expected_updated_at: this.updatedAt,
                    objects: this.objects.filter(object => this.changed.includes(object.building_process_id)).map(object => ({building_process_id: object.building_process_id, access_config: object.access_config}))});
                this.$emit('input', false); this.$emit('saved');
            } catch (error) {this.error = error.response && error.response.data.msg || 'Не удалось сохранить настройки';}
            finally {this.saving = false;}
        }
    }
};
</script>
